module.exports = __webpack_public_path__ + "img/content_title4.46089e41.png";